import { ReactNode } from 'react';
import AdminHeader from './AdminHeader';
import AdminBottomNav from './AdminBottomNav';
import AnimatedPage from './AnimatedPage';

interface AdminLayoutProps {
  children: ReactNode;
}

function AdminLayout({ children }: AdminLayoutProps) {
  return (
    <div>
      <AdminHeader />
      <main className="mobile-content">
        <AnimatedPage>
          {children}
        </AnimatedPage>
      </main>
      <AdminBottomNav />
    </div>
  );
}

export default AdminLayout;

